var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-button',{attrs:{"icon":_vm.$icons.new,"title":"Add new block"},on:{"action":_vm.addNew}})}
var staticRenderFns = []

export { render, staticRenderFns }